import { render } from "./file-uploads-block-component.vue?vue&type=template&id=290e6e11"
import script from "./file-uploads-block-component.vue?vue&type=script&lang=js"
export * from "./file-uploads-block-component.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__